import { Box, Dialog, IconButton, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import RepartionEspecesChequesRetrait from "./rep-especes-cheques-retrait";
import { CurrencyExchange } from "@mui/icons-material";
import EspecesExchange from "./especes-exchange";

export default function Step3(props) {
    const [exchanging, setExchanging] = useState(false)
    const ttEspeces = useMemo(()=>props.petiteCaisse.reduce((tt,esp)=>tt+esp.montant*esp.count,0),[props.petiteCaisse])

    return(
        <Box>
            <Typography variant="h6" align="center">Répartition de la part locale</Typography>
            <Typography variant="subtitle1" align="center" color='red'>Vous disposer de {props.local_part?.toFixed(2)}€ de part locale à répartir</Typography>
            {props.take_petite_caisse&&<>
                <Box display='flex' justifyContent='space-between' alignItems='center' marginTop={2} marginBottom={1}>
                    <Typography variant="subtitle1">Petite-caisse</Typography>
                    {props.eglise.money_switch&&<IconButton onClick={()=>setExchanging(true)}><CurrencyExchange/></IconButton>}
                </Box>
            <RepartionEspecesChequesRetrait  { ...{repespeces:props.petiteCaisse, setRepEspeces:props.setPetiteCaisse, dispoMoney: props.dispoMoney, isPetiteCaisse:true}}/>
            </>}
            
            <Typography variant="h6" fontWeight='bold' align="center" marginTop={2}>Montant total réparti: {ttEspeces.toFixed(2)}€</Typography>
            
            <Dialog open={exchanging} maxWidth='md' fullWidth onClose={()=>{setExchanging(false); props.cancelExchange()}}>
                <Box sx={{padding:2}}>
                    <EspecesExchange {...{close:()=>setExchanging(false), setEmptyAndclose:()=>{setExchanging(false); props.cancelExchange()}, dons: props.dons, setDispoMoney: props.setDispoMoney, exchange: props.exchange, setExchange: props.setExchange}}/>
                </Box>
            </Dialog>
        </Box>
    )
}